/* Built in */
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppComponent } from './assets/components/app/app.component';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';

/* Third Party */
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import 'hammerjs';
import { MdAutocompleteModule,
  MdButtonModule,
  MdButtonToggleModule,
  MdCardModule,
  MdCheckboxModule,
  MdChipsModule,
  MdCoreModule,
  MdDatepickerModule,
  MdDialogModule,
  MdExpansionModule,
  MdGridListModule,
  MdIconModule,
  MdInputModule,
  MdListModule,
  MdMenuModule,
  MdNativeDateModule,
  MdPaginatorModule,
  MdProgressBarModule,
  MdProgressSpinnerModule,
  MdRadioModule,
  MdRippleModule,
  MdSelectModule,
  MdSidenavModule,
  MdSliderModule,
  MdSlideToggleModule,
  MdSnackBarModule,
  MdSortModule,
  MdTableModule,
  MdTabsModule,
  MdToolbarModule,
  MdTooltipModule
} from '@angular/material';
import { AngularFireModule } from 'angularfire2';
import { AngularFireDatabaseModule } from 'angularfire2/database';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { CdkTableModule } from '@angular/cdk';

export const firebaseConfig = {
  apiKey: "AIzaSyDtp-ybJHK9ZNIFVX7aoqs_qpqv_EHcfJw",
  authDomain: "wb-management-system.firebaseapp.com",
  databaseURL: "https://wb-management-system.firebaseio.com",
  projectId: "wb-management-system",
  storageBucket: "wb-management-system.appspot.com",
  messagingSenderId: "400261162103"
};

/* Custom */
import { LoginComponent } from './assets/components/login/login.component';
import { PageNotFoundComponent } from './assets/components/error/page-not-found.component';
import { DashboardComponent } from './assets/components/dashboard/dashboard.component';
import { UserService } from './assets/services/user.service';
import { DatabaseService } from './assets/services/database.service';
import { HttpService } from './assets/services/http.service';

import { LeaveComponent } from './assets/components/leave/leave.component';
import { SalaryComponent } from './assets/components/salary/salary.component';
import { TaxesComponent } from './assets/components/taxes/taxes.component';
import { WebsitesComponent } from './assets/components/websites/websites.component';
import { MailComponent } from './assets/components/mail/mail.component';
import { DialogAddWebsiteComponent } from './assets/components/dialogs/dialog-add-website.component';
import { DialogEditProfileComponent } from './assets/components/dialogs/dialog-edit-profile.component';
import { DialogShowInfoComponent } from './assets/components/dialogs/dialog-show-info.component';
import { DialogAddHostComponent } from './assets/components/dialogs/dialog-add-host.component';
import { DialogAddLeaveComponent } from './assets/components/dialogs/dialog-add-leave.component';

// Routing
import { routing } from './app.routing';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    PageNotFoundComponent,
    DashboardComponent,
    LeaveComponent,
    SalaryComponent,
    TaxesComponent,
    DialogAddWebsiteComponent,
    WebsitesComponent,
    MailComponent,
    DialogEditProfileComponent,
    DialogShowInfoComponent,
    DialogAddHostComponent,
    DialogAddLeaveComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpModule,
    routing,
    MdAutocompleteModule,
    MdButtonModule,
    MdButtonToggleModule,
    MdCardModule,
    MdCheckboxModule,
    MdChipsModule,
    MdCoreModule,
    MdDatepickerModule,
    MdDialogModule,
    MdExpansionModule,
    MdGridListModule,
    MdIconModule,
    MdInputModule,
    MdListModule,
    MdMenuModule,
    MdNativeDateModule,
    MdPaginatorModule,
    MdProgressBarModule,
    MdProgressSpinnerModule,
    MdRadioModule,
    MdRippleModule,
    MdSelectModule,
    MdSidenavModule,
    MdSliderModule,
    MdSlideToggleModule,
    MdSnackBarModule,
    MdSortModule,
    MdTableModule,
    MdTabsModule,
    MdToolbarModule,
    MdTooltipModule,
    AngularFireModule.initializeApp(firebaseConfig),
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    CdkTableModule
  ],
  exports: [
    MdAutocompleteModule,
    MdButtonModule,
    MdButtonToggleModule,
    MdCardModule,
    MdCheckboxModule,
    MdChipsModule,
    MdCoreModule,
    MdDatepickerModule,
    MdDialogModule,
    MdExpansionModule,
    MdGridListModule,
    MdIconModule,
    MdInputModule,
    MdListModule,
    MdMenuModule,
    MdNativeDateModule,
    MdPaginatorModule,
    MdProgressBarModule,
    MdProgressSpinnerModule,
    MdRadioModule,
    MdRippleModule,
    MdSelectModule,
    MdSidenavModule,
    MdSliderModule,
    MdSlideToggleModule,
    MdSnackBarModule,
    MdSortModule,
    MdTableModule,
    MdTabsModule,
    MdToolbarModule,
    MdTooltipModule,
  ],
  entryComponents: [
    DialogAddWebsiteComponent,
    DialogEditProfileComponent,
    DialogShowInfoComponent,
    DialogAddHostComponent,
    DialogAddLeaveComponent
  ],
  providers: [UserService,DatabaseService,HttpService],
  bootstrap: [AppComponent]
})
export class AppModule { }


// WEBPACK FOOTER //
// /home/gideon/webbest/projects/wb-management-system/frontend/wb-management-system/src/app/app.module.ts